import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { bootstrapWithLanguage } from "./app/utils/bootstrap-with-language-standalone";

// Get language from URL query parameter if present
const searchParams = new URLSearchParams(window.location.search);
const langQueryParam = searchParams.get("lang") || null;
if (langQueryParam) {
  searchParams.delete("lang");
  const search = searchParams.toString();
  window.history.replaceState(
    window.history.state,
    window.document.title,
    window.location.pathname + (search.length > 0 ? "?" + search : ""),
  );
}

// Use standalone bootstrapping with language support
bootstrapWithLanguage(AppComponent, langQueryParam, appConfig.providers).catch(
  (err: Error) => console.error(err),
);
